import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ProductFamilyPage from './pages/ProductFamilyPage';


function App() {


  return (
    <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products/:family" element={<ProductFamilyPage />} />        
        </Routes>

    </BrowserRouter>
  );
}

export default App;